export default __webpack_public_path__ + "static/AwardFinal-b61fdc79f88303894be65fa85c6bee28.png";